<template>
	<div class="default-layout">
		<div class="ui top fixed huge borderless menu">
			<div class="right menu">
				<language-selector></language-selector>
			</div>
		</div>
		<alert></alert>
		<child/>
	</div>
</template>

<script>
import MobileDetect from 'mobile-detect'

export default {
	name: 'default-layout',

	mounted () {
		this.checkIfIE()
			.then(result => {
				if (result) {
					this.$events.$emit('alert', {
						header: this.$t('globals.validation.errors.oops_outdated_browser'),
						message: this.$t('globals.validation.errors.outdated_browser_message'),
						type: 'error',
						closebutton: true,
						align: 'center',
						timer: 0
					})
				}
			})
	},

	methods: {
		checkIfIE () {
			return new Promise((resolve, reject) => {
				var md = new MobileDetect(navigator.userAgent)
				if (md.versionStr('IE')) {
					resolve(true)
				} else {
					resolve(false)
				}
			})
		}
	}
}
</script>

<style>
	.default-layout {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100vh;
	}
</style>




// WEBPACK FOOTER //
// src/layouts/default.vue